import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import { ColorBoxField as EditComponent } from '../tsx/ColorBoxField';

declare var Color: any;

export class ColorBoxField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [
        //LL: don't use this validator, it permits only string that is hex or rgb/rgba or "transparent"
        //    now it can be also null and standard color names ("red")
        //validators.color.shouldBe
    ];

    public static EditComponent = EditComponent;

    public isEqual(value1, value2) {
        if (value1 == null) {
            return value2 == null;
        } else if (value2 == null) {
            return value1 == null;
        }

        return Color(value1).hexString() === Color(value2).hexString();
    }

    constructor(glob: IGlob, title: string, validators?: any, defaultVal: any = '#ffffff', options?) {
        super(glob, title, ColorBoxField.defaultValidators, validators, defaultVal, options);
    }
}
